export enum BuildingIndicatorCode {
    ENERGY_CONSUMPTION_BY_SURFACE = 'energyConsumptionBySurface',
    PRIMARY_CONSUMPTION_BY_SURFACE = 'primaryConsumptionBySurface',
    CO2 = 'co2',
    CO2_BY_SURFACE = 'co2BySurface',
    ENERGY_CONSUMPTION = 'energyConsumption'
}
